import React from 'react';
import isElectron from '../../utils/isElectron';
import { exchangeDmsCode, getDmsAuthUrl } from '../../store/slices/dms.slice';
import { once, run } from '../../helper/electron';
import { AppDispatch } from '../../store/store';
import { useDispatch } from 'react-redux';
import { IonButton } from '@ionic/react';

export const DmsLoginButton: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const handleDmsLogin = async () => {
    const url = await dispatch(getDmsAuthUrl()).unwrap();

    if (isElectron()) {
      once('loginDMS', async (data) => {
        if (!data.message || data.message.includes('ERROR')) {
          console.error('Error logging into dms');
        } else {
          await dispatch(exchangeDmsCode(data.message)).unwrap();
        }
      });
      run('loginDMS', { authUrl: url });
    }
  };

  return (
    <IonButton fill="clear" size="small" onClick={handleDmsLogin}>
      Sign in to Direct Download
    </IonButton>
  );
};
